import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class UIPreferencesService {
    private displayRoundedValues$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    displayRoundedValuesObservable: Observable<boolean> = this.displayRoundedValues$.asObservable();

    constructor() {}

    public setDisplayRoundedValues(value: boolean) {
    this.displayRoundedValues$.next(value);
    }

    public getDisplayRoundedValues(): boolean {
    return this.displayRoundedValues$.getValue();
    }
}